module.exports = __webpack_public_path__ + "img/1439247558.d0f545ee.jpg";